import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { PieChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import BasicECharts from 'components/common/BasicEChart';
import {
  GridComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer
]);

const getOptions = (data, radius, total) => ({
  color: data.map(item => getColor(item.color)),
  tooltip: {
    padding: [7, 10],
    transitionDuration: 0,
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('gray-1100') },
    borderWidth: 1,
    formatter: params => {
      return `<strong>${params.data.name}:</strong> ${params.data.value}`;
    }
  },
  series: [
    {
      name: total,
      type: 'pie',
      radius,
      avoidLabelOverlap: false,
      emphasis: {
        scale: false
      },
      itemStyle: {
        borderWidth: 0.5,
        borderColor: getColor('gray-100')
      },
      label: {
        show: true,
        position: 'center',
        formatter: '{a}',
        fontSize: 23,
        color: 'gray'
      },
      data
    }
  ]
});

const MarketShareItem = ({ item, index, total }) => {
  const { name, color, value } = item;

  const percentage = ((value * 100) / total).toFixed(1);
  return (
    <Flex
      alignItems="center"
      justifyContent="between"
      className={`fw-semibold fs-11 ${index == 0 && 'mt-1'}`}
    >
      <div style={{ fontSize: 14, marginRight: 2 }}>
        <FontAwesomeIcon
          icon="circle"
          style={{ color: getColor(color), marginRight: 2 }}
        />
        {name}
      </div>
      <div style={{ fontSize: 14, fontWeight: 500 }}>{percentage}%</div>
    </Flex>
  );
};

const MarketShare = ({ data, radius, title, summary, isShowLegend = true }) => {
  if (data && Array.isArray(data) && data.length > 0) {
    let total = data.reduce((acc, val) => val.value + acc, 0);
    return (
      <Card style={{ width: 425, minHeight: 155 }}>
        <Card.Body>
          <Row className="justify-content-between g-0">
            <Col xs={5} sm={6} xxl className="pe-2">
              <div style={{ fontSize: 16, fontWeight: 500, color: '#344050' }}>
                {title}
              </div>
              {isShowLegend &&
                data.map((item, index) => (
                  <MarketShareItem
                    item={item}
                    index={index}
                    key={index}
                    total={total}
                  />
                ))}
            </Col>
            <Col xs="auto">
              <div className="ps-0">
                <BasicECharts
                  echarts={echarts}
                  options={getOptions(data, radius, summary ? summary : total)}
                  style={{ width: '7rem', height: '7rem' }}
                />
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }

  return <></>;
};

MarketShareItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  }),
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};

MarketShare.propTypes = {
  data: PropTypes.array.isRequired,
  radius: PropTypes.array.isRequired,
  title: PropTypes.string,
  isShowLegend: PropTypes.bool,
  summary: PropTypes.string
};

export default MarketShare;
